import { loadTooltipFeedback, setTooltipFeedback } from "@/common/utils/storage";
import { useState, useMemo } from "react";
import { CurrentUserObject } from "@/common/hooks/useVisitorInfo";
import { useUserSettingsHandlers } from "@/common/hooks/useUserSettingsHandlers";

export const useDismissNicheTooltip = (user: CurrentUserObject | null) => {
  const { updateUserSettings } = useUserSettingsHandlers();

  const initialTooltipState = useMemo(() => {
    const tooltipStoredValue = loadTooltipFeedback();
    if (tooltipStoredValue) {
      return true;
    }
    if (user?.settings?.dismiss_niche_feedback_tooltip) {
      return true;
    }
    return false;
  }, [user]);

  const [showTooltip, setShowTooltip] = useState<boolean>(initialTooltipState);

  const onDismissNicheTooltip = (forceClose: boolean) => {
    if (!showTooltip) {
      if (forceClose) {
        setShowTooltip(true);
        return;
      }

      setTooltipFeedback(true);
      setShowTooltip(true);

      if (user && Object.keys(user).length > 0) {
        updateUserSettings({ dismiss_niche_feedback_tooltip: true });
      }
    }
  };

  return {
    isDismissNicheTooltip: showTooltip,
    onDismissNicheTooltip,
  };
};
